export const messages = {
  page: {
    header: {
      id: 'healthSummary.SendSecurely.Page.Header',
      defaultMessage: 'Send Securely',
    },
  },
  explanation: {
    transmitType: {
      id: 'healthSummary.SendSecurely.Explanation.TransmitType',
      defaultMessage: 'Direct Address',
    },
    primary: {
      top: {
        id: 'healthSummary.SendSecurely.Explanation.Primary.Top',
        defaultMessage:
        'Send your Health Information Summary directly to a care provider using our secure message system.',
      },
      bottom: {
        id: 'healthSummary.SendSecurely.Explanation.Primary.Bottom',
        defaultMessage:
        `You must know their {transmitType}, which is like an email address but is more secure.
        If you do not know the provider's {transmitType}, contact their office.`,
      },
    },
    secondary: {
      id: 'healthSummary.SendSecurely.Explanation.Secondary',
      defaultMessage: 'Your Health Summary will be automatically attached to this message when sent.',
    },
  },
  recipient: {
    label: {
      id: 'healthSummary.SendSecurely.Recipient.Label',
      defaultMessage: 'To',
    },
    placeholder: {
      id: 'healthSummary.SendSecurely.Recipient.Placeholder',
      defaultMessage: 'Care Provider\'s Direct Address',
    },
    validation: {
      id: 'healthSummary.SendSecurely.Recipient.Validation',
      defaultMessage: 'Enter a valid Direct Address: someone@direct.Com',
    },
  },
  body: {
    label: {
      id: 'healthSummary.SendSecurely.Body.Label',
      defaultMessage: 'Message',
    },
    placeholder: {
      id: 'healthSummary.SendSecurely.Body.Placeholder',
      defaultMessage: 'Type your message here (optional)...',
    },
  },
  send: {
    label: {
      id: 'healthSummary.SendSecurely.Send.Label',
      defaultMessage: 'Send',
    },
  },
  cancel: {
    label: {
      id: 'healthSummary.SendSecurely.Cancel.Label',
      defaultMessage: 'Cancel',
    },
  },
};
